import React, { FC, PropsWithChildren } from 'react';

import DatePicker, { DatePickerProps } from '../DatePicker/DatePicker';

export type DateRangePickerProps = DatePickerProps & { selectsRange: true };

const DateRangePicker: FC<
  PropsWithChildren<Omit<DateRangePickerProps, 'selectsRange'>>
> = props => (
  <DatePicker selectsRange inline monthsShown={2} disabledKeyboardNavigation {...props} />
);

export default DateRangePicker;
